module.exports = __webpack_public_path__ + "static/media/6.46c5dc58.png";